import { useEffect, useState } from 'react';
import { RefreshCw, WifiOff, ServerCrash, AlertTriangle } from 'lucide-react';
import './LoadingScreen.css';

export default function LoadingFailure({ error, compact = false, onRefresh = () => window.location.reload() }) {
  const [offline, setOffline] = useState(() => typeof navigator !== 'undefined' && navigator.onLine === false);
  useEffect(() => {
    const update = () => setOffline(navigator.onLine === false);
    window.addEventListener('online', update); window.addEventListener('offline', update);
    return () => { window.removeEventListener('online', update); window.removeEventListener('offline', update); };
  }, []);
  const server = Number(error?.status) >= 500;
  const Icon = offline ? WifiOff : server ? ServerCrash : AlertTriangle;
  return <section role="alert" className={`bnw-load-failure ${compact ? 'bnw-load-failure--compact' : ''}`}>
    <div className="bnw-load-failure__icon" aria-hidden="true"><Icon size={42} strokeWidth={1.5} /><span /></div>
    <h1>{offline ? 'No internet connection' : server ? 'Server unavailable' : 'Unable to open this page'}</h1>
    <p>{offline ? 'Reconnect to the internet, then refresh to try again.' : server ? 'The server is not responding. Please refresh in a moment.' : 'We couldn’t load this page. Your connection or the service may be temporarily unavailable.'}</p>
    <button type="button" onClick={onRefresh}><RefreshCw size={18} aria-hidden="true" /> Refresh</button>
  </section>;
}
